import { Lead } from '../../generated/api/lead.js';
import { getCookie } from './cookieUtils.js';

export type StoredParametersCookie = {
  gaSource?: string;
  gaMedium?: Lead.GaMediumEnum;
  gaCampaign?: string;
  gaContent?: string;
  gaTerm?: string;
  gaClientId?: string;
  gaSessionId?: string;
};

const SP_KEY_MAP: [string, keyof StoredParametersCookie][] = [
  ['source', 'gaSource'],
  ['medium', 'gaMedium'],
  ['campaign', 'gaCampaign'],
  ['content', 'gaContent'],
  ['term', 'gaTerm'],
  ['ga_client_id', 'gaClientId'],
  ['ga_session_id', 'gaSessionId'],
];

export const getStoredParametersCookie = (): StoredParametersCookie | undefined => {
  const cookieString = getCookie('stored_parameters');
  if (cookieString != null) {
    try {
      const cookie = JSON.parse(decodeURIComponent(cookieString));
      const storedParameters: StoredParametersCookie = SP_KEY_MAP.reduce<StoredParametersCookie>((spc, field) => {
        const value = cookie[field[0]];
        if (typeof value === 'string') {
          if (field[1] === 'gaMedium') {
            if (value in Lead.GaMediumEnum) {
              spc[field[1]] = Lead.GaMediumEnum[value as keyof typeof Lead.GaMediumEnum];
            }
          } else if (value !== '' && value != null) {
            spc[field[1]] = value;
          }
        }
        return spc;
      }, {});
      return storedParameters;
    } catch (e) {
      return undefined;
    }
  }
  return undefined;
};
